import React from 'react';
export const WarningSigns = () => {
  return <div className="w-full bg-white py-12 WarningSigns" data-id="element-326">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-327">
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-328">
          <div className="md:w-1/2" data-id="element-329">
            <h2 className="text-2xl font-bold text-green-900 mb-4" data-id="element-330">
              What are the signs?
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-331">
              Many dog owners know the signs of bad breath because you smell it
              every time your dog comes close. But did you know that chronic bad
              breath is actually a warning sign of deeper health issues? Here
              are some common signs to look out for:
            </p>
            <ul className="space-y-2 mb-6" data-id="element-332">
              <li className="flex items-start" data-id="element-333">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1" data-id="element-334">
                  <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-335"></div>
                </div>
                <span data-id="element-336">Bad breath that doesn't go away</span>
              </li>
              <li className="flex items-start" data-id="element-337">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1" data-id="element-338">
                  <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-339"></div>
                </div>
                <span data-id="element-340">Yellow or brown teeth</span>
              </li>
              <li className="flex items-start" data-id="element-341">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1" data-id="element-342">
                  <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-343"></div>
                </div>
                <span data-id="element-344">Red or inflamed gums</span>
              </li>
              <li className="flex items-start" data-id="element-345">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1" data-id="element-346">
                  <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-347"></div>
                </div>
                <span data-id="element-348">Excessive drooling</span>
              </li>
              <li className="flex items-start" data-id="element-349">
                <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1" data-id="element-350">
                  <div className="h-2 w-2 bg-green-500 rounded-full" data-id="element-351"></div>
                </div>
                <span data-id="element-352">Difficulty eating or loss of appetite</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6" data-id="element-353">
              <button className="bg-amber-600 text-white font-semibold py-3 px-6 rounded-full hover:bg-amber-500 transition" onClick={() => {
              document.querySelector('.WhyItMatters')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-354">
                Learn More
              </button>
              
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-355">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jqXpTc1GYiKaQ32ddatdfR/Image_fx_%284%29.jpg" alt="Veterinarian checking dog's teeth" className="rounded-lg shadow-md w-full" data-id="element-356" />
          </div>
        </div>
      </div>
    </div>;
};